import { useEffect, useRef } from 'react';
import { ADSENSE_CLIENT } from '../../constants';

export default function AdUnit({
  slot,
  format = 'auto',
  className = '',
  client = ADSENSE_CLIENT,
}) {
  const adRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (!slot || !adRef.current || pushed.current) {
      return undefined;
    }

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {
      /* AdSense not loaded yet */
    }

    return undefined;
  }, [slot]);

  if (!slot) {
    return null;
  }

  return (
    <div className={`ad-container ${className}`.trim()}>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
